module.exports = __webpack_public_path__ + "img/pic28.4f533bae.png";